import React from "react";
import { WavesBackground } from "../../atoms";
import { LuStar } from "react-icons/lu";
import { cn } from "../../../util/general";

const variants = {
  default: {
    card: "bg-white text-slate-950 border border-slate-200",
    waves: "text-slate-100",
    icon: "bg-slate-100 text-slate-700",
  },
  primary: {
    card: "bg-blue-700 text-white border border-blue-600",
    waves: "text-blue-400/30",
    icon: "bg-blue-800 text-slate-100",
  },
  dark: {
    card: "bg-slate-900 text-white border border-slate-800",
    waves: "text-slate-800",
    icon: "bg-slate-800 text-slate-100",
  },
};

export const CardHeader = ({ title, subtitle, icon, className, variant = "default" }) => {
  const currentVariant = variants[variant] || variants.default;

  return (
    <div className={cn("flex flex-row items-center gap-2", className)}>
      <div className={cn("rounded-xl p-2.5 shrink-0", currentVariant.icon)}>
        {icon ? icon : <LuStar size={24} />}
      </div>

      <div className="flex flex-col items-start">
        <span className="text-lg font-extrabold leading-tight">{title ?? "-"}</span>
        <span className="text-xs font-light leading-tight opacity-60">
          {subtitle ?? "Total"}
        </span>
      </div>
    </div>
  );
};

const Card = ({ children, variant = "default", className, ...props }) => {
  const currentVariant = variants[variant] || variants.default;

  return (
    <div
      className={cn(
        "relative flex flex-col items-start gap-4 px-5 py-5 overflow-hidden rounded-[32px]",
        currentVariant.card,
        className
      )}
      {...props}
    >
      <WavesBackground
        className={cn(
          "absolute left-0 w-full -translate-y-1/2 top-1/2 z-[2]",
          currentVariant.waves
        )}
      />
      <div className="flex flex-col items-start flex-1 w-full gap-2 z-[4]">{children}</div>
    </div>
  );
};

export default Card;
